import React from 'react'
import moment from 'moment'

import InfiniteScroll from 'react-infinite-scroll-component'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

const useStyles = makeStyles(theme => ({
  root: {
    height: 'fit-content',
    maxHeight: 450
  },
  removeStyle: {
    '& .content': {
      wordBreak: 'break-all'
    },
    fontSize: 14,
    '& p, h1, h2, h3': {
      margin: 0,
      padding: 0
    }
  }
}))

const NotificationsMenu = ({
  history,
  notifications,
  getNotifications,
  fractalId,
  viewNotification,
  clearNotifications,
  handleCloseMail
}) => {
  const classes = useStyles()

  const canShowEndMsg = !(notifications.total_count === 0)

  const resetNotification = () => {
    clearNotifications()
    getNotifications()
  }

  React.useEffect(() => {
    resetNotification()
    return () => {
      clearNotifications()
    }
  }, [])

  const handleClickNotification = async item => {
    await viewNotification({ notificationId: item.id })
    resetNotification()
    handleCloseMail()
    history.push(`/rooms/${item.room_id}`)
  }

  return (
    <List
      className={classes.root}
      component='nav'
      aria-label='secondary mailbox folders'
    >
      <InfiniteScroll
        dataLength={notifications?.items?.length}
        height={'30vh'}
        next={() => {
          getNotifications({
            page: notifications?.current_page + 1
          })
        }}
        loader={<h4>Carregando...</h4>}
        className={classes.infiniteScroll}
        hasMore={notifications?.items?.length !== notifications.total_count}
        endMessage={
          canShowEndMsg && (
            <p style={{ textAlign: 'center' }}>
              <b>Todas as notificações.</b>
            </p>
          )
        }
      >
        {notifications?.items?.length > 0 ? (
          notifications?.items.map((item, index) => {
            const roomName =
              item?.room?.room_type === 'private'
                ? `${
                    item?.room?.room_participants.find(
                      rp => +rp.user.fractal_id !== +fractalId
                    ).user.name
                  } enviou uma mensagem.`
                : `Nova mensagem em ${item?.room?.name}`
            const sendMsgAuthor = (
              <span style={{ fontWeight: 900 }}>{roomName}</span>
            )
            const msgText = item?.room?.last_message.content?.substring(0, 60)
            return (
              <ListItem
                style={{ maxWidth: 300 }}
                key={`listItem-message-${index}`}
                button
                onClick={() => handleClickNotification(item)}
              >
                <ListItemText
                  primary={
                    <span className={classes.removeStyle}>
                      {sendMsgAuthor}
                      <p
                        className='content'
                        dangerouslySetInnerHTML={{
                          __html: msgText
                        }}
                      />
                    </span>
                  }
                  secondary={moment(item?.created_at)
                    .startOf('minute')
                    .fromNow()}
                />
              </ListItem>
            )
          })
        ) : (
          <ListItem style={{ maxWidth: 300 }} key={`listItem-without-message`}>
            <ListItemText
              primary={
                <span className={classes.removeStyle}>
                  Não há notificações pendentes no momento.
                </span>
              }
            />
          </ListItem>
        )}
      </InfiniteScroll>
    </List>
  )
}

export default NotificationsMenu
